import {
  Component, OnInit, ViewChild, OnDestroy,Renderer2,
  ElementRef, AfterViewInit, ChangeDetectorRef, HostListener
} from "@angular/core";
// import { ROUTES } from './vertical-menu-routes.config';
import { SideNavService } from '../services/sideNav.service';
import { HROUTES } from '../horizontal-menu/navigation-routes.config';

import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { customAnimations } from "../animations/custom-animations";
import { DeviceDetectorService } from 'ngx-device-detector';
import { ConfigService } from '../services/config.service';
import { Subscription } from 'rxjs';
import { LayoutService } from '../services/layout.service';
import { decryptValue } from "../data/encryption";
import { is } from "core-js/core/object";


@Component({
  selector: "app-sidebar",
  templateUrl: "./vertical-menu.component.html",
  animations: customAnimations
})
export class VerticalMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('toggleIcon') toggleIcon: ElementRef;
  public menuItems: any[];
  level: number = 0;
  logoUrl = 'assets/img/cf_logo_icon_new';
  public config: any = {};
  protected innerWidth: any;
  layoutSub: Subscription;
  configSub: Subscription;
  perfectScrollbarEnable = true;
  collapseSidebar = false;
  resizeTimeout;
  expanded: boolean;
  nav_collapsed_open = false;
  isCustomerAdmin :boolean = false;
  isCustomer : boolean = false;
  isAdmin : boolean = false;
  constructor(
    private router: Router,
    public translate: TranslateService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private deviceService: DeviceDetectorService
  ) {
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;
    this.isTouchDevice();
  }


  ngOnInit() {
    this.menuItems = new SideNavService().routeInfo;
    // ⭐ Ensure sidebar renders on mobile at start
    if (window.innerWidth < 1200) {
      this.config.layout.menuPosition = 'Side';
    }
  }

  ngAfterViewInit() {

    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();

    });

    this.layoutSub = this.layoutService.overlaySidebarToggle$.subscribe(
      collapse => {
        if (this.config.layout.menuPosition === "Side") {
          this.collapseSidebar = collapse;
        }
      });



  }
  toggleSlideInOut() {
    this.expanded = !this.expanded;
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
      if (this.resizeTimeout) {
          clearTimeout(this.resizeTimeout);
      }
      this.resizeTimeout = setTimeout((() => {
        this.innerWidth = event.target.innerWidth;
          this.loadLayout();
      }).bind(this), 500);
  }

  loadLayout() {
     this.isCustomerAdmin = localStorage.getItem('IsCustomerAdmin') ?  decryptValue(localStorage.getItem('IsCustomerAdmin')) == "Y" ? true : false : false;
        this.isAdmin = JSON.parse(decryptValue(localStorage.getItem('RoleAliasName'))).indexOf('ADMIN') > -1 ? true : false
        // if(this.isAdmin || this.isCustomerAdmin){
        //   HROUTES[0].Role = true
        // } else {
        //   HROUTES[0].Role = false
        // }
       this.isCustomer = localStorage.getItem('IsCustomer') ?  decryptValue(localStorage.getItem('IsCustomer')) == "Y" ? true : false : false;

       const isMobile = localStorage.getItem('isMobile') ? decryptValue(localStorage.getItem('isMobile')) == "true" ? true : false : false;
       console.log("isMobile from localstorage", isMobile)
       const boxDataExists = localStorage.getItem('boxDataQR') ? decryptValue(localStorage.getItem('boxDataQR')) == 'true' ? true : false : false;
        console.log("boxDataExists from localstorage", boxDataExists)
     
      //  console.log("this.isCustomer", HROUTES[1].submenu.filter((item) => item.title == 'Upload ASCII')[0].Role)
        // if (this.isCustomer) {
        //   HROUTES[1].submenu.filter((item) => item.title == 'Upload ASCII')[0].Role = false
        //   HROUTES[1].submenu.filter((item) => item.title == 'ASCII Audits')[0].Role = false
        //   HROUTES[1].submenu.filter((item) => item.title == 'Archived Samples')[0].Role = false
        //   HROUTES[1].submenu.filter((item) => item.title == 'Dashboard')[0].Role = false
        // } else {
        //   HROUTES[1].submenu.filter((item) => item.title == 'Upload ASCII')[0].Role = true
        //   HROUTES[1].submenu.filter((item) => item.title == 'ASCII Audits')[0].Role = true
        //   HROUTES[1].submenu.filter((item) => item.title == 'Archived Samples')[0].Role = true
        //   HROUTES[1].submenu.filter((item) => item.title == 'Dashboard')[0].Role = true
        // }
   //   HROUTES[1].submenu.filter((item) => item.title == 'Add Sample')[0].Role = true
      HROUTES[0].Role = false
    HROUTES[1].submenu.map((item) => {
      if (item.title == "Add Sample" || item.title == "View All Samples") {
        item.Role = true
      } else if (item.title == "Add Box Data" && boxDataExists) {
        item.Role = true
      }
      else {
        item.Role = false
      }
    })


    if (this.config.layout.menuPosition === "Top") { // Horizontal Menu
      if (this.innerWidth < 1200) { // Screen size < 1200
        this.menuItems = HROUTES;
      }
    }
    else if (this.config.layout.menuPosition === "Side") { // Vertical Menu{
      this.menuItems =  HROUTES
    }

    console.log("menuItems", this.menuItems)




    if (this.config.layout.sidebar.backgroundColor === 'white') {
      this.logoUrl = 'assets/img/cf_logo_icon_new.png';
      console.log("white")
    }
    else {
      this.logoUrl = 'assets/img/cf_logo_icon_new.png';
      console.log("black")
    }

    if(this.config.layout.sidebar.collapsed) {
      this.collapseSidebar = true;
    }
    else {
      this.collapseSidebar = false;
    }
  }

  toggleSidebar() {
    let conf = this.config;
    conf.layout.sidebar.collapsed = !this.config.layout.sidebar.collapsed;
    this.configService.applyTemplateConfigChange({ layout: conf.layout });

    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }

  fireRefreshEventOnWindow = function () {
    const evt = document.createEvent("HTMLEvents");
    evt.initEvent("resize", true, false);
    window.dispatchEvent(evt);
  };

  CloseSidebar() {
    this.layoutService.toggleSidebarSmallScreen(false);
  }

  isTouchDevice() {

    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();

    if (isMobile || isTablet) {
      this.perfectScrollbarEnable = false;
    }
    else {
      this.perfectScrollbarEnable = true;
    }

  }


  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }

  }

}
